import { render, staticRenderFns } from "./PaperlessPolicy.vue?vue&type=template&id=5157e24e"
import script from "./PaperlessPolicy.vue?vue&type=script&lang=js"
export * from "./PaperlessPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports